// extracted by mini-css-extract-plugin
module.exports = {"iconClose":"IconClose_iconClose__1PlBR"};